import * as React from 'react';
import { useState } from 'react';
import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';
import { addMasterLock, MasterLockIndividualLock } from '../../../../../api/PropertyIntegration';
import Button from '../../../../common/form/Button';
import FormInput from '../../../../common/form/Input';
import { userIsCompanyManageUser, userIsPropertyManageUser, userIsSystemManageUser } from '../../../../../utilities/identity';

const isUser =
    userIsCompanyManageUser() ||
    userIsPropertyManageUser() ||
    userIsSystemManageUser();

interface Props {
    propertyId: number;
    handleAddLockSuccess: (lockInfo: MasterLockIndividualLock) => void;
    setError: (error: string | undefined) => void;
    setLoading: (loading: boolean) => void;
}

export const MasterLockNewLockInput = (props: Props) => {
    const [newLockName, setNewLockName] = useState<string>('');
    const [newDisplayName, setNewDisplayName] = useState<string>('');
    const [newLockId, setNewLockId] = useState<string>('');
    const [newLockActivationCode, setNewLockActivationCode] = useState<string>('');

    const inputsValid =
        newLockName.length > 0 && newLockId.length > 0 && newLockActivationCode.length > 0;

    const handleAddLock = async () => {
        if (!inputsValid) {
            window.alert('Please enter lock details');
            return;
        }

        let lockInfo: MasterLockIndividualLock = {
            lockName: newLockName,
            deviceIdentifier: newLockId,
            displayName: newDisplayName,
            isEnabled: true
        };

        props.setLoading(true);

        let result = await addMasterLock(props.propertyId, {
            ...lockInfo,
            activationCode: newLockActivationCode
        });

        if (result.success) {
            props.handleAddLockSuccess(lockInfo);
            props.setError(undefined);
            setNewLockName('');
            setNewDisplayName('');
            setNewLockId('');
            setNewLockActivationCode('');
        } else {
            props.setError(result.error);
        }

        props.setLoading(false);
    };

    return (
        <div>
            <Row>
                <Col md={3}>
                    <div>
                        <FormInput
                            labelProps={{ labelText: 'Lock Name' }}
                            inputProps={{
                                id: 'lock-name',
                                name: 'lockName',
                                value: newLockName,
                                disabled: isUser
                            }}
                            onChange={(_name, value) => setNewLockName(value.toString())}
                        />
                    </div>
                </Col>
                <Col md={3}>
                    <div>
                        <FormInput
                            labelProps={{ labelText: 'Display Name' }}
                            inputProps={{
                                id: 'display-name',
                                name: 'displayName',
                                value: newDisplayName,
                                disabled: isUser
                            }}
                            onChange={(_name, value) => setNewDisplayName(value.toString())}
                        />
                    </div>
                </Col>
                <Col md={3}>
                    <div>
                        <FormInput
                            labelProps={{ labelText: 'Device ID' }}
                            inputProps={{
                                id: 'lock-id',
                                name: 'lockId',
                                value: newLockId,
                                disabled: isUser
                            }}
                            onChange={(_name, value) => setNewLockId(value.toString())}
                        />
                    </div>
                </Col>
                <Col md={3}>
                    <div>
                        <FormInput
                            labelProps={{ labelText: 'Sharing Code' }}
                            inputProps={{
                                id: 'activation-code',
                                name: 'activationCode',
                                value: newLockActivationCode,
                                disabled: isUser
                            }}
                            onChange={(_name, value) => setNewLockActivationCode(value.toString())}
                        />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Button suppressBottomMargin={true} text="Add Another" onClick={handleAddLock} disabled={isUser}/>
                </Col>
            </Row>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/integrationControls/MasterLockNewLockInput.tsx